import { Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "../../controls";
import { Form } from "../../layout";
import { Model, UseForm } from "../../hooks";
import { useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";

import { controller, endpoints } from "../../api/actions/api";
import * as actions from "../../api/actions/pos";

import {
IsEmptyObj,
RmvEmptyProp,
RmvNullProp,
ToFormData,
} from "../../hooks/Method";

const AddEditCustomer = (props) => {
const { t } = useTranslation();  
const {
_post,
_put,
_data,
_clear,
_type,
_getById,
_authUser,
_store,
} = props;

const { CustomersMdl } = Model();

const navigate = useNavigate();

const [loading, setLoading] = useState(false);

const { id } = useParams();

const isAddMode = !id;

//------------------------------------------------
// Form
//------------------------------------------------
const {
values,
setValues,
errors,
setErrors,
handleInpChg,
} = UseForm(CustomersMdl);

//------------------------------------------------
// Validation
//------------------------------------------------
const validateForm = () => {
let temp = {};

temp.customerName =
  values.customerName !== ""
    ? ""
    : t("customerNameRequired");

temp.phone =
  values.phone !== ""
    ? ""
    : t("phoneRequired");

temp.email =
  values.email === "" ||
  /^$|.+@.+..+$/.test(values.email)
    ? ""
    : t("invalidEmail");

setErrors({ ...temp });

return Object.values(temp).every(
  (x) => x === ""
);

};

//------------------------------------------------
// Submit
//------------------------------------------------
const handleSubmit = (e) => {
e.preventDefault();

if (!validateForm()) return;

// Assign current store and logged-in user
values.storeId = _store.id;
values.userId = _authUser.id;

setLoading(true);


const onComplete = (res) => {
  setLoading(false);

  if (res?.status === 200) {
    navigate("/customers");
  }
};


//------------------------------------------------
// Add Customer
//------------------------------------------------
if (isAddMode) {

  _post(
    endpoints.Customer,
    ToFormData(
      RmvEmptyProp(values)
    ),
    null,
    onComplete
  );

}

//------------------------------------------------
// Update Customer
//------------------------------------------------
else {

  values.id = id;

  _put(
    endpoints.Customer,
    ToFormData(
      RmvEmptyProp(values)
    ),
    null,
    onComplete
  );

}

};

//------------------------------------------------
// Load Customer for Edit
//------------------------------------------------
useEffect(() => {

if (!isAddMode) {

  _getById(
    endpoints.Customer + controller.GetById,
    id,
    actions.ActionType.Data
  );

}


return () => {

  _clear();

  _clear(
    {},
    actions.ActionType.ClearData
  );

};
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [id]);

//------------------------------------------------
// Set Edit Values
//------------------------------------------------
useEffect(() => {

if (
  !isAddMode &&
  !IsEmptyObj(_data) &&
  _type === "customer"
) {

  setValues({
    ...values,
    ...RmvNullProp(_data),
  });

}
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [_data]);

//------------------------------------------------
// UI
//------------------------------------------------
return (
<> <Paper className="mt-30 shadow-xs br-8">

    <Form
      noValidate
      onSubmit={handleSubmit}
    >

      <Grid
        container
        spacing={3}
        className="p-20 pt-0"
      >

        {/* Title */}

        <Grid
          item
          xs={12}
          className="tx-center mt-20"
        >

          <Typography
            variant="h5"
            className="fs-22 gray-color fw-5 tx-upp"
          >

            {isAddMode
              ? t("addCustomer")
              : t("updateCustomer")}

          </Typography>

          <div className="bs-bottom mx-w-80 m-auto mt-10 mb-30" />

        </Grid>


        {/* Customer Name */}

        <Grid item xs={12}>

          <Input
            label={t("customerName")}
            name="customerName"
            value={values.customerName}
            error={errors.customerName}
            onChange={handleInpChg}
            fullWidth
            inputProps={{
              maxLength: 300,
            }}
          />

        </Grid>


        {/* Phone */}

        <Grid
          item
          xs={12}
          md={6}
        >

          <Input
            label={t("phone")}
            name="phone"
            value={values.phone}
            error={errors.phone}
            onChange={handleInpChg}
            fullWidth
            inputProps={{
              maxLength: 200,
            }}
          />

        </Grid>


        {/* Email */}

        <Grid
          item
          xs={12}
          md={6}
        >

          <Input
            label={t("email")}
            name="email"
            value={values.email}
            error={errors.email}
            onChange={handleInpChg}
            fullWidth
            inputProps={{
              maxLength: 350,
            }}
          />

        </Grid>


        {/* Address */}

        <Grid item xs={12}>

          <Input
            label={t("address")}
            name="address"
            value={values.address}
            error={errors.address}
            onChange={handleInpChg}
            fullWidth
            inputProps={{
              maxLength: 800,
            }}
          />

        </Grid>


        {/* City */}

        <Grid
          item
          xs={12}
          md={4}
        >

          <Input
            label={t("city")}
            name="city"
            value={values.city}
            error={errors.city}
            onChange={handleInpChg}
            fullWidth
            inputProps={{
              maxLength: 400,
            }}
          />

        </Grid>


        {/* State */}

        <Grid
          item
          xs={12}
          md={4}
        >

          <Input
            label={t("state")}
            name="state"
            value={values.state}
            error={errors.state}
            onChange={handleInpChg}
            fullWidth
            inputProps={{
              maxLength: 400,
            }}
          />

        </Grid>


        {/* ZIP */}

        <Grid
          item
          xs={12}
          md={4}
        >

          <Input
            label={t("zip")}
            name="zip"
            value={values.zip}
            error={errors.zip}
            onChange={handleInpChg}
            fullWidth
            inputProps={{
              maxLength: 300,
            }}
          />

        </Grid>


        {/* Notes */}

        <Grid item xs={12}>

          <Input
            label={t("notes")}
            name="notes"
            multiline
            rows={3}
            value={values.notes}
            error={errors.notes}
            onChange={handleInpChg}
            fullWidth
            inputProps={{
              maxLength: 1000,
            }}
          />

        </Grid>


        {/* Submit */}

        <Grid
          item
          xs={12}
          className="tx-right"
        >

          <Button
            loading={loading}
            type="submit"
            sx={{
              width: {
                md: "150px",
                xs: "100%",
              },
            }}
            size="large"
          >

            {isAddMode
              ? t("submit")
              : t("saveChanges")}

          </Button>

        </Grid>

      </Grid>

    </Form>

  </Paper>
</>


);
};

//------------------------------------------------
// Redux
//------------------------------------------------
const mapStateToProps = (state) => ({
_data: state.pos.data,
_type: state.pos.type,
_authUser: state.pos.authUser,
_store: state.pos.defStore,
});

const mapActionToProps = {
_post: actions.post,
_put: actions.put,
_getById: actions.getById,
_clear: actions.clear,
};

export default connect(
mapStateToProps,
mapActionToProps
)(AddEditCustomer);
